import React, { Component, Button } from 'react';
import DropdownTreeSelectContainer from './DropDownContainer'
import { StoreCreationPopup } from './CreatorPopup/StoreCreatorPopup';
import 'react-dropdown-tree-select/dist/styles.css'


export class StoresSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categoryData: {
                label: 'loading...',
                value: 'loading...',
                isDefaultValue: true,
                disabled: true,
                children: []
            }
        };
    }

    static defaultProps = {
        onSelection: (id) => { }
    }


    componentDidMount() {
        this.populateCategoryList();
    }

    async populateCategoryList() {
        const response = await fetch(`api/location/get-stores-tree`);
        const data = await response.json();
        this.setState({ categoryData: data});
    }

    onChange = (currentNode, selectedNodes) => {
        if (selectedNodes.length > 0) {
            this.props.onSelection(selectedNodes[0].value);
        }
    }

    render() {
        const onSubmit = () => {
            this.populateCategoryList();
        };

        return (
            <div>
                <div style={{ display: 'inline-block' }}>
                    <DropdownTreeSelectContainer data={this.state.categoryData} onChange={this.onChange} mode={'radioSelect'} />
                </div>
                <div style={{ display: 'inline-block', verticalAlign: 'top', paddingLeft: "5px" }}>
                    {this.props.allowCreate &&
                        <StoreCreationPopup triggerText={"Create New"} onSubmit={onSubmit} />}
                </div>
            </div>
        );
    }
}
